package repositories

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.get
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import practicetest.MaterialsResponse
import uk.co.happyukrainians.HttpClientEngineForPlatform

class HttpClientMaterialRepository(engine: HttpClientEngine = HttpClientEngineForPlatform()) : MaterialRepository {
    private val client: HttpClient = HttpClient(engine) {
        install(ContentNegotiation) {
            json(Json { ignoreUnknownKeys = true })
        }
    }
    override suspend fun fetchMaterials(subject: String, topic: String): Result<MaterialsResponse> {
        return try {
            val httpResponse = client.get("https://api.happyukrainian.com/subject/$subject/topic/$topic/materials").call.response
            if (httpResponse.status != HttpStatusCode.OK) {
                Result.failure(MaterialRepositoryException(isNetwork = false))
            } else {
                Result.success(httpResponse.body<MaterialsResponse>())
            }
        } catch (e: Throwable) {
            Result.failure(MaterialRepositoryException(isNetwork = true))
        }
    }
}